( function ( $ ) {

  const $modal = $( '#video-modal' )
  if ( !$modal.length ) { return }

  const $mtitle = $( '.modal-title', $modal )
  const $mbody = $( '.modal-body', $modal )
  let modal

  $modal.on( 'show.bs.modal', function ( e ) {
    console.log( e )
    console.log( e.relatedTarget )
    if ( ! e.relatedTarget ) { return }
    const $article = $( e.relatedTarget ).closest( 'article' )
    console.log( $article )
    $mtitle.text( $article.data( 'title' ) )
    $mbody.html(
      $( '<iframe>' )
        .attr( 'id', $article.data( 'uniqid' ) )
        .attr( 'src', $article.data( 'url' ) )
        .attr( 'title', 'Video Player' )
        .attr( 'allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; allowfullscreen; gyroscope; picture-in-picture' )
    )
  })
  $modal.on( 'hide.bs.modal', function ( e ) {
    console.log( e )
    if ( ! e.currentTarget ) { return }
    const $article = $( e.currentTarget ).closest( 'article' )
    $mbody.html(
        $( '<iframe>' )
          .attr( 'id', $article.data( 'uniqid' ) )
          .attr( 'src', $article.data( 'url' ) )
          .attr( 'title', 'Video Player' )
          .attr( 'allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; allowfullscreen; gyroscope; picture-in-picture' )
    )
});

})( jQuery )